/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Download_InvoiceInputs */



/**
* | output |
* | --- |
* | "Download" |
*
* @param {Download_InvoiceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const download_invoice = /** @type {((inputs?: Download_InvoiceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Download_InvoiceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Télécharger")
	if (locale === "de") return /** @type {LocalizedString} */ ("Herunterladen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scaricamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скачать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descargar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("下载")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ダウンロード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डाउनलोड करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Download")
	return /** @type {LocalizedString} */ ("Download")
});